"use client";

import Link from "next/link";
import styles from "./Footer.module.css";

const MAP_IMAGE = "/assets/images/map-image.png";
const ICON_LOCATION = "http://localhost:3845/assets/72806e7ff76905212393d2785f33f13eeafdc583.svg";
const ICON_CALL = "http://localhost:3845/assets/1a8c474aafb49cd1985caf31336856ccb4fd48fe.svg";
const ICON_MAIL = "http://localhost:3845/assets/29e3284d823a1c4219252800474045f090b8177c.svg";
const ICON_CLOCK = "http://localhost:3845/assets/f2384e4c84763217eb3c317e0d096fc217a5b23d.svg";
const ICON_OPEN = "http://localhost:3845/assets/2c942b03f62b7778410c51cd1d9cc7311d495091.svg";

const themes = {
  ent: {
    logo: "/assets/Icons/ent-logo-1.png",
    logoAlt: "ENT Central Logo",
    brandName: "ENT CENTRAL",
  },
  cosmetic: {
    logo: "/assets/Icons/cosmetic-central-logo.png",
    logoAlt: "Cosmetic Central Logo",
    brandName: "COSMETIC CENTRAL",
  },
};

export default function Footer({ theme = "ent" }) {
  const currentTheme = themes[theme] ?? themes.ent;
  const themeClass = styles[theme] ?? "";

  return (
    <footer className={`${styles.footer} ${themeClass}`}>
      <div className={styles.container}>
        <div className={styles.brandSection}>
          <div className={styles.brandHeader}>
            <div className={styles.logo}>
              <img src={currentTheme.logo} alt={currentTheme.logoAlt} className={styles.logoImage} />
            </div>
            <h3 className={styles.brandName}>{currentTheme.brandName}</h3>
          </div>
          <p className={styles.brandText}>
            Proving expert care for Ear, Nose & Throat conditions with compassion and advanced technology
          </p>
          <div className={styles.ctaSection}>
            <Link href="/book" className={styles.ctaButton}>
              Book An Appointment
            </Link>
          </div>
        </div>

        <div className={styles.linksSection}>
          <h3 className={styles.sectionHeading}>QUICKLINKS</h3>
          <ul className={styles.links}>
            <li><Link href="/endoliftx">ENDOLIFTX</Link></li>
            <li><Link href="/cosmetic-central">COSMETIC CENTRAL</Link></li>
            <li><Link href="/ladylift">LADYLIFT</Link></li>
            <li><Link href="/services">SERVICES</Link></li>
            <li><Link href="/about-dr-naveed">ABOUT DR NAVEED</Link></li>
            <li><Link href="/our-clinic">OUR CLINIC</Link></li>
            <li><Link href="/shop">SHOP NOW</Link></li>
          </ul>
        </div>

        <div className={styles.contactSection}>
          <h3 className={styles.sectionHeading}>CONTACT US</h3>
          <div className={styles.contactItem}>
            {/* <img src={ICON_LOCATION} alt="" className={styles.contactIcon} /> */}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M16 10C16 7.79 14.21 6 12 6C9.79 6 8 7.79 8 10C8 12.21 9.79 14 12 14C14.21 14 16 12.21 16 10ZM10 10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 11.1 13.1 12 12 12C10.9 12 10 11.1 10 10Z" fill="#EBEBEB" />
              <path d="M11.4201 21.81C11.5901 21.93 11.8001 22 12.0001 22C12.2001 22 12.4101 21.94 12.5801 21.81C12.8801 21.59 20.0301 16.44 20.0001 9.98999C20.0001 5.57999 16.4101 1.98999 12.0001 1.98999C7.59009 1.98999 4.00009 5.57999 4.00009 9.98999C3.97009 16.43 11.1201 21.59 11.4201 21.81ZM12.0001 3.99999C15.3101 3.99999 18.0001 6.68999 18.0001 9.99999C18.0201 14.44 13.6101 18.43 12.0001 19.74C10.3901 18.43 5.98009 14.45 6.00009 9.99999C6.00009 6.68999 8.69009 3.99999 12.0001 3.99999Z" fill="#EBEBEB" />
            </svg>
            <div className={styles.contactText}>
              <p>187 Broadway Avenue</p>
              <p>Palmerston North.</p>
            </div>
          </div>
          <div className={styles.contactItem}>
            {/* <img src={ICON_CALL} alt="" className={styles.contactIcon} /> */}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M7.82888 16.171C5.67828 14.0163 4.02439 11.4177 2.98288 8.55702C2.40988 6.99302 2.93488 5.27502 4.11288 4.09702L4.84188 3.36902C5.03786 3.17264 5.27066 3.01684 5.52693 2.91053C5.78321 2.80423 6.05793 2.74951 6.33538 2.74951C6.61282 2.74951 6.88755 2.80423 7.14382 2.91053C7.4001 3.01684 7.63289 3.17264 7.82888 3.36902L9.53588 5.07602C9.73226 5.27201 9.88806 5.5048 9.99437 5.76108C10.1007 6.01735 10.1554 6.29208 10.1554 6.56952C10.1554 6.84697 10.1007 7.12169 9.99437 7.37797C9.88806 7.63424 9.73226 7.86704 9.53588 8.06302L9.11588 8.48302C8.94776 8.6511 8.8144 8.85065 8.72342 9.07028C8.63243 9.2899 8.5856 9.5253 8.5856 9.76302C8.5856 10.0007 8.63243 10.2361 8.72342 10.4558C8.8144 10.6754 8.94776 10.8749 9.11588 11.043L12.9559 14.884C13.124 15.0521 13.3235 15.1855 13.5431 15.2765C13.7628 15.3675 13.9982 15.4143 14.2359 15.4143C14.4736 15.4143 14.709 15.3675 14.9286 15.2765C15.1482 15.1855 15.3478 15.0521 15.5159 14.884L15.9369 14.464C16.1329 14.2676 16.3657 14.1118 16.6219 14.0055C16.8782 13.8992 17.1529 13.8445 17.4304 13.8445C17.7078 13.8445 17.9825 13.8992 18.2388 14.0055C18.4951 14.1118 18.7279 14.2676 18.9239 14.464L20.6309 16.171C20.8273 16.367 20.9831 16.5998 21.0894 16.8561C21.1957 17.1124 21.2504 17.3871 21.2504 17.6645C21.2504 17.942 21.1957 18.2167 21.0894 18.473C20.9831 18.7292 20.8273 18.962 20.6309 19.158L19.9029 19.886C18.7249 21.065 17.0069 21.59 15.4429 21.017C12.5822 19.9755 9.98364 18.3216 7.82888 16.171Z" stroke="#EBEBEB" stroke-width="1.5" stroke-linejoin="round" />
            </svg>
            <p className={styles.contactText}>0800 ENT DOC (368 362)</p>
          </div>
          <div className={styles.contactItem}>
            {/* <img src={ICON_MAIL} alt="" className={styles.contactIcon} /> */}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M2.35693 7.714L9.33693 12.368C10.2999 13.009 10.7809 13.33 11.3009 13.455C11.7609 13.565 12.2399 13.565 12.6989 13.455C13.2189 13.33 13.6999 13.009 14.6629 12.368L21.6429 7.714M7.15693 19.5H16.8429C18.5229 19.5 19.3629 19.5 20.0049 19.173C20.569 18.8852 21.0276 18.4263 21.3149 17.862C21.6429 17.22 21.6429 16.38 21.6429 14.7V9.3C21.6429 7.62 21.6429 6.78 21.3159 6.138C21.0283 5.57354 20.5694 5.11462 20.0049 4.827C19.3629 4.5 18.5229 4.5 16.8429 4.5H7.15693C5.47693 4.5 4.63693 4.5 3.99493 4.827C3.43084 5.11479 2.97229 5.57369 2.68493 6.138C2.35693 6.78 2.35693 7.62 2.35693 9.3V14.7C2.35693 16.38 2.35693 17.22 2.68393 17.862C2.97155 18.4265 3.43047 18.8854 3.99493 19.173C4.63693 19.5 5.47693 19.5 7.15693 19.5Z" stroke="#EBEBEB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <p className={styles.contactText}>admin@entcentral.co.nz</p>
          </div>
          <div className={styles.contactItem}>
            {/* <img src={ICON_CLOCK} alt="" className={styles.contactIcon} /> */}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 8V12L15 15M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#EBEBEB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <p className={styles.contactText}>Mon - Fri : 8.30 AM - 5.00 PM</p>
          </div>
        </div>

        <div className={styles.mapSection}>
          <div className={styles.mapContainer}>
            <img src={MAP_IMAGE} alt="Clinic Location Map" className={styles.mapImage} />
            <button className={styles.mapButton}>
              <span>Open in Maps</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M8.3335 3.33325H5.00016C4.55814 3.33325 4.13421 3.50885 3.82165 3.82141C3.50909 4.13397 3.3335 4.55789 3.3335 4.99992V14.9999C3.3335 15.4419 3.50909 15.8659 3.82165 16.1784C4.13421 16.491 4.55814 16.6666 5.00016 16.6666H15.0002C15.4422 16.6666 15.8661 16.491 16.1787 16.1784C16.4912 15.8659 16.6668 15.4419 16.6668 14.9999V11.6666M10.0002 9.99992L16.6668 3.33325M12.5002 3.33325H16.6668V7.49992" stroke="#0055B6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
